import { __awaiter } from "tslib";
import { RcsbFvCoreBuilder } from "./RcsbFvCoreBuilder";
import { RcsbFvGroupAnnotation } from "../RcsbFvModule/RcsbFvGroupAnnotation";
import { RcsbFvGroupAlignment } from "../RcsbFvModule/RcsbFvGroupAlignment";
export class RcsbFvGroupBuilder {
    //TODO How to make this method more general. Variables from, to and group should be parameters. What happens when from cannot be defined ?
    static buildGroupAnnotationFv(elementId, group, groupId, to, from, additionalConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                try {
                    RcsbFvCoreBuilder.createFv({
                        elementId: elementId,
                        fvModuleI: RcsbFvGroupAnnotation,
                        config: {
                            group: group,
                            groupId: groupId,
                            from: from,
                            to: to,
                            additionalConfig: additionalConfig,
                            resolve: resolve
                        }
                    });
                }
                catch (e) {
                    reject(e);
                }
            });
        });
    }
    static buildGroupAlignmentFv(elementId, group, groupId, to, from, additionalConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                try {
                    RcsbFvCoreBuilder.createFv({
                        elementId: elementId,
                        fvModuleI: RcsbFvGroupAlignment,
                        config: {
                            group: group,
                            groupId: groupId,
                            from: from,
                            to: to,
                            additionalConfig: Object.assign({}, additionalConfig),
                            resolve: resolve
                        }
                    });
                }
                catch (e) {
                    reject(e);
                }
            });
        });
    }
}
//# sourceMappingURL=RcsbFvGroupBuilder.js.map